/* Oilsu storefront behaviour: qty steppers, variant switching, ajax add to cart,
   cart count refresh, predictive search. No dependencies. */
(function () {
  if (window.__oilsuInit) return;
  window.__oilsuInit = true;

  var money = function (cents) {
    var fmt = window.Shopify && Shopify.currency ? Shopify.currency.active : 'USD';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: fmt }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  };

  /* ---------- qty steppers ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-step]');
    if (!btn) return;
    e.preventDefault();
    var input = btn.parentElement.querySelector('input');
    var min = parseInt(input.min || '1', 10);
    var next = (parseInt(input.value, 10) || min) + parseInt(btn.dataset.qtyStep, 10);
    input.value = Math.max(min, Math.min(9999, next));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- variant select inside a table row ---------- */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-variant-select]');
    if (!sel) return;
    var row = sel.closest('[data-product-row]');
    var opt = sel.options[sel.selectedIndex];
    var price = row.querySelector('[data-price]');
    var stock = row.querySelector('[data-stock]');
    var add = row.querySelector('[data-add]');
    if (price) price.textContent = money(parseInt(opt.dataset.price, 10));
    if (stock) {
      var available = opt.dataset.available === 'true';
      var qty = parseInt(opt.dataset.inventory || '0', 10);
      stock.className = 'ot-stock' + (!available ? ' is-out' : qty > 0 && qty < 10 ? ' is-low' : '');
      stock.textContent = !available ? 'Out of stock' : qty > 0 && qty < 10 ? 'Low · ' + qty : 'In stock';
      if (add) {
        add.disabled = !available;
        add.textContent = available ? 'Add' : 'Notify me';
      }
    }
  });

  /* ---------- ajax add to cart ---------- */
  function refreshCartCount() {
    return fetch(window.Shopify.routes.root + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count === 1 ? '1 item' : cart.item_count + ' items';
        });
        document.querySelectorAll('[data-cart-total]').forEach(function (el) {
          el.textContent = money(cart.total_price);
        });
        document.dispatchEvent(new CustomEvent('oilsu:cart-updated', { detail: cart }));
        return cart;
      });
  }
  window.oilsuRefreshCart = refreshCartCount;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var row = btn.closest('[data-product-row], [data-product-form]');
    var sel = row.querySelector('[data-variant-select]');
    var id = sel ? sel.value : row.querySelector('[name="id"]').value;
    var qtyEl = row.querySelector('[data-qty-input]');
    var qty = qtyEl ? (parseInt(qtyEl.value, 10) || 1) : 1;
    var label = btn.textContent;
    btn.textContent = 'Adding…';
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: qty }] })
    })
      .then(function (r) { return r.json().then(function (b) { if (!r.ok) throw b; return b; }); })
      .then(function () {
  if (window.__oilsuInit) return;
  window.__oilsuInit = true;

        btn.textContent = 'Added ✓';
        if (qtyEl) qtyEl.value = qtyEl.min || 1;
        return refreshCartCount();
      })
      .catch(function (err) { btn.textContent = (err && err.description) ? 'Not available' : 'Try again'; })
      .then(function () {
  if (window.__oilsuInit) return;
  window.__oilsuInit = true;
 setTimeout(function () {
  if (window.__oilsuInit) return;
  window.__oilsuInit = true;
 btn.textContent = label; }, 1600); });
  });

  /* ---------- cart line quantity changes (cart page) ---------- */
  var t;
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-line]');
    if (!input) return;
    clearTimeout(t);
    t = setTimeout(function () {
  if (window.__oilsuInit) return;
  window.__oilsuInit = true;

      fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: Number(input.dataset.cartLine), quantity: parseInt(input.value, 10) || 0 })
      }).then(function () {
  if (window.__oilsuInit) return;
  window.__oilsuInit = true;
 window.location.reload(); });
    }, 350);
  });

  /* ---------- predictive search ---------- */
  var box = document.querySelector('[data-predictive]');
  if (box) {
    var input = box.querySelector('input[name="q"]');
    var out = box.querySelector('[data-suggest]');
    var timer;
    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { out.hidden = true; out.innerHTML = ''; return; }
      timer = setTimeout(function () {
  if (window.__oilsuInit) return;
  window.__oilsuInit = true;

        fetch(window.Shopify.routes.root + 'search/suggest.json?q=' + encodeURIComponent(q) +
              '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var items = (data.resources.results.products || []);
            if (!items.length) { out.hidden = true; return; }
            out.innerHTML = items.map(function (p) {
              return '<a href="' + p.url + '"><span>' + p.title + '</span><span class="ot-mono">' + p.price + '</span></a>';
            }).join('');
            out.hidden = false;
          });
      }, 180);
    });
    document.addEventListener('click', function (e) { if (!box.contains(e.target)) out.hidden = true; });
  }
})();